<template>
  <NavbarOne />
  <PageBanner
    pageTitle="تفاصيل الخدمة"
    subTitle="تعرف على مميزات اشتراكات IPTV، الأجهزة المدعومة، جودة البث، والمحتوى المتوفر لتختار الخدمة المناسبة لك."
    :pageBannerImage="pageBannerImg"
  />
  <ServicesDetails />
  <SubscribeContent />
  <MainFooter class="bg-black" />
  <CopyRight />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useHead } from "@unhead/vue";
import NavbarOne from "@/components/Layouts/NavbarOne.vue";
import PageBanner from "@/components/Common/PageBanner.vue";
import ServicesDetails from "@/components/ServicesDetails/index.vue";
import SubscribeContent from "@/components/Common/SubscribeContent.vue";
import MainFooter from "@/components/Layouts/MainFooter.vue";
import CopyRight from "@/components/Layouts/CopyRight.vue";

export default defineComponent({
  name: "ServicesDetailsPage",
  components: {
    NavbarOne,
    PageBanner,
    ServicesDetails,
    SubscribeContent,
    MainFooter,
    CopyRight,
  },
  setup() {
    useHead({
      title: "تفاصيل خدمات IPTV | المميزات والأجهزة المدعومة",
      meta: [
        {
          name: "description",
          content:
            "اكتشف جميع تفاصيل خدمات IPTV، بما في ذلك القنوات العربية والعالمية، الأفلام والمسلسلات، جودة HD و4K، الأجهزة المدعومة، ومزايا كل اشتراك.",
        },
        {
          name: "keywords",
          content:
            "خدمات IPTV, تفاصيل IPTV, اشتراك IPTV, أجهزة IPTV, Smart TV, Android TV, IPTV HD, IPTV 4K, قنوات عربية",
        },
        {
          property: "og:title",
          content: "تفاصيل خدمات IPTV | المميزات والأجهزة المدعومة",
        },
        {
          property: "og:description",
          content:
            "تعرف على مميزات خدمات IPTV، جودة البث، والأجهزة المدعومة قبل اختيار الاشتراك المناسب.",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "robots",
          content: "index, follow",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://karamtv4k.com/services-details",
        },
      ],
    });

    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const pageBannerImg = require("@/assets/images/page-banner-8.jpg");

    return {
      pageBannerImg,
    };
  },
});
</script>